"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KojiLaTeXConverter = void 0;
const KojiConverter_1 = require("./KojiConverter");
const inline_rules_1 = require("./inline_rules");
const block_rules_1 = require("./block_rules");
const Mustache = require("mustache");
class KojiLaTeXConverter {
    constructor(options) {
        this.inlineConversionRuleMap = {};
        this.blockConversionRuleMap = {};
        inline_rules_1.default.forEach((rule) => {
            this.inlineConversionRuleMap[rule.elemName] = rule;
        });
        block_rules_1.default.forEach((rule) => {
            this.blockConversionRuleMap[rule.elemName] = rule;
        });
        if (options && options.rules) {
            options.rules.forEach((rule) => {
                KojiConverter_1.assertConversionRuleIsValid(rule);
                if (rule.type === 'inline') {
                    this.inlineConversionRuleMap[rule.elemName] = rule;
                }
                else if (rule.type === 'block') {
                    this.blockConversionRuleMap[rule.elemName] = rule;
                }
            });
        }
    }
    convert(ast) {
        const children = this.convertChildren([ast.body]);
        return this.document(`${children.join('')}`);
    }
    convertChildren(children) {
        return children.map((content) => {
            return content
                .map((node) => {
                if (typeof node === 'string') {
                    if (node === '\n')
                        return '\\\\\n';
                    return `${node}`;
                }
                else if (this.isBlockNode(node)) {
                    return this.convertBlock(node);
                }
                else if (this.isInlineNode(node)) {
                    return this.convertInline(node);
                }
            })
                .join('');
        });
    }
    convertInline(node) {
        if (this.inlineConversionRuleMap[node.name]) {
            const rule = this.inlineConversionRuleMap[node.name];
            return Mustache.render(rule.latexTemplate, this.buildMustacheVariables(node));
        }
        else {
            const children = this.convertChildren(node.children).join('');
            return `${children}`;
        }
    }
    convertBlock(node) {
        const children = this.convertChildren(node.children).join('');
        return `${children}`;
    }
    buildMustacheVariables(node) {
        const children = this.convertChildren(node.children);
        const vars = {};
        vars['$0'] = children;
        for (let i = 0; i < 10; i++) {
            if (children[i]) {
                vars[`$${i + 1}`] = children[i];
            }
        }
        return vars;
    }
    isBlockNode(block) {
        return block.type === 'block';
    }
    isInlineNode(block) {
        return block.type === 'inline';
    }
    document(content) {
        return `% みんなで翻刻テキストLaTeXエクスポート（試験版）
% 金水敏先生が公開するkunten2e.sty(http://www.let.osaka-u.ac.jp/~kinsui/tex/kunten2e.sty)を使用してコンパイルしてください

\\documentclass[dvipdfmx,autodetect-engine]{utbook}% 
\\usepackage{kuten2e,color}
\\usepackage[normalem]{ulem}
\\begin{document}
${content}
\\end{document}
`;
    }
}
exports.KojiLaTeXConverter = KojiLaTeXConverter;
//# sourceMappingURL=data:application/json;base64,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